import { B2BDeliveryOrder, B2BOrderArgs } from 'api/app/order/types';
import { createContext, FC, ReactNode, useContext } from 'react';
import { useEstimateFee } from '../../hooks/useEstimateFee';

type EstimateFeeContextActions = {
  orderArgs: B2BOrderArgs<
    Omit<B2BDeliveryOrder, 'total_pay' | 'e_invoice'>
  > | null;
  estimateFee: () => void;
  result: any;
  isEstimateFeeError: boolean;
  disablePayViaCash: boolean;
  errMessageEstimateFee: string;
};

const EstimateFeeContext = createContext({} as EstimateFeeContextActions);

interface EstimateFeeContextProviderProps {
  children: ReactNode;
}

const EstimateFeeProvider: FC<EstimateFeeContextProviderProps> = ({
  children,
}) => {
  const value = useEstimateFee();

  return (
    <EstimateFeeContext.Provider value={value}>
      {children}
    </EstimateFeeContext.Provider>
  );
};

const useEstimateFeeContext = (): EstimateFeeContextActions => {
  const context = useContext(EstimateFeeContext);

  if (!context) {
    throw new Error(
      'useEstimateFeeContext must be used within an EstimateFeeProvider'
    );
  }

  return context;
};

export { EstimateFeeProvider, useEstimateFeeContext };
